module.exports = __webpack_public_path__ + "como-font.ttf?e61c829e1f921c7174de498c6ea9fa2d";